import React from 'react';
import { Input, useT } from '@repo/common';

const EmailInputBlock = ({
  value,
  focused,
  inputRef,
  state,
  message,
  onChange,
  onFocus,
  onBlur,
  isRequired = false,
}) => {
  const t = useT();

  const getEmailValue = () => {
    if (Array.isArray(value)) {
      return value[0] || '';
    }
    return value || '';
  };

  const emailValue = getEmailValue();

  return (
    <div className='relative min-w-[260px] w-full'>
      <Input
        ref={inputRef}
        label={focused ? `${t('Email', '이메일')}*` : ''}
        value={emailValue}
        state={state}
        hideCount
        message={message}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={isRequired ? '' : t('E-mail', '이메일')}
        className='placeholder:opacity-0 md:max-w-[380px]'
      />

      {!emailValue && !focused && (
        <span className='absolute left-4 top-[25%] text-text-placeholder pointer-events-none'>
          {isRequired && (
            <>
              {t('E-mail', '이메일')}
              <span className='text-text-accent ml-0.5'>*</span>
            </>
          )}
        </span>
      )}
    </div>
  );
};

export default EmailInputBlock;
